import PageNotFound from '@/components/PageNotFound.vue'
import apiDeck from '@/features/apiDeck/apiDeck.routes'
import cashflowForecast from '@/features/cashflowForecast/cashflowForecast.routes'
import creditSafeRoutes from '@/features/creditSafe/creditSafe.routes'
import dashboard from '@/features/dashboard/dashboard.routes'
import dataRoom from '@/features/dataRoom/dataRoom.routes'
import insurance from '@/features/insurance/insurance.routes'
import integrations from '@/features/integrations/integrations.routes'
import onboarding from '@/features/onboarding/onboarding.routes'
import profile from '@/features/profile/profile.routes'
import resetPassword from '@/features/resetPassword/resetPassword.routes'
import savings from '@/features/savings/savings.routes'
import login from '@/features/signIn/signIn.routes'
import plaid from '@/features/plaid/plaid.routes'
import truelayer from '@/features/truelayer/truelayer.routes'
import xeroSSORoutes from '@/features/xeroSSO/xeroSSO.routes'
import router from '@/router/index'
import additionalProductRoutes from '@product/components/additional-product/additionalProduct.routes'
import aggregator from '@product/features/aggregator/aggregator.routes'
import funding from '@product/features/funding/funding.routes'
import products from '@product/features/products/products.routes'
import embeds from '@/features/embeds/embedded.routes'
import application from '@/features/application/application.routes'
import sageAuth from '@/features/sage/sage.routes'
import businessHealth from '@/features/businessHealth/businessHealth.routes'
import apiOnboarding from '@/features/apiOnboarding/ApiOnboarding.routes'
import chat from '@/features/chat/chat.routes'
import defaultRoute from './default.routes'

export default () => {
  defaultRoute('stage')
  xeroSSORoutes()
  login()
  aggregator()
  products()
  onboarding()
  dashboard()
  profile()
  savings()
  dataRoom()
  insurance()
  cashflowForecast()
  truelayer()
  plaid()
  apiDeck()
  integrations()
  resetPassword()
  funding()
  additionalProductRoutes()
  creditSafeRoutes()
  embeds()
  sageAuth()
  application()
  businessHealth()
  apiOnboarding()
  chat()

  // Match everything else and redirect to Not Found page
  router.addRoute({
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: PageNotFound
  })
}
